import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData } from '../../services/sessionsServices';
import { Button, Modal, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty } from '../../utils/common';

const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};

const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video',
];

const Sessions = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});   
  console.log('errors',errors);

  const [data, setData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null, 
    session_name: '',
    session_title: '',
    session_description: '',
    short_description: '',
    alt_name: '',
    session_url: '',
    meta_title: '',
    meta_description: ''  
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);  
  const [searchText, setSearchText] = useState('');


  const normalizeTitle = (title)=> title?.replace(/-/g,' ');


  // Fetch data from API
      const fetchData = useCallback(async () => {
        setLoading(true);
        try { 
            const response = await getData();
            console.log('res',response);
            const updatedData = response.map((item) => ({
              ...item,
              session_title: normalizeTitle(item.session_title)
            }));
            setData(updatedData);
        }
        catch (error) { 
          console.error('Error fetching data:', error);
        }
        finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);
    
     // Validate form data
    const validateForm = () => {
    const newErrors = {};
    if (!formData.session_name) newErrors.session_name = "Order is required";
    if (!formData.session_title) newErrors.session_title = "Session Title is required";
    if (!formData.uploadedfile && formData.uploadedfile === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Session Image is required";
     }
    if ( isQuillContentEmpty(formData.session_description.trim())) newErrors.session_description = "Long Description is required";
    if ( isQuillContentEmpty(formData.short_description.trim())) newErrors.short_description = "Short Description is required";
    if (!formData.alt_name) newErrors.alt_name = "Alt Name is required";
    if (!formData.meta_title) newErrors.meta_title = "Meta Title is required";
    if (!formData.meta_description) newErrors.meta_description = "Meta Description is required";
    if (formData.meta_title.length < 20 || formData.meta_title.length > 70) newErrors.meta_title = "Meta Title should be between 20 and 70 characters";
    if (formData.meta_description.length < 70 || formData.meta_description.length > 160) newErrors.meta_description = "Meta Description should be between 70 and 160 characters";
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
  }
  
    const handleChange = async (e) => {
      try{
              const { name, value, files } = e.target;
              const file = files?.[0]
                // Create a copy of the current form data
                let updatedData = { ...formData };
                let updatedErrors = { ...errors };
                if (file) {
                    const fileType = file.type.includes("image") ? "img" : "pdf";
                    const isValid = await validateFile(file, setErrors,name,fileType);
                    if (isValid) {
                      updatedData[name] = file;
                      updatedErrors[name] = '';
                    }
                    else{
                      return ; // Don't update if invalid
                    }
              } 
                else{
                updatedData[name] = value;
                if (value) {
                updatedErrors[name] = ''; // Clear error if corrected
              }
              if (name === 'session_name') {
                if (value.trim() === '') {
                updatedErrors[name] = "Order is required";
              }
              else if (Number(value) === 0) {
                updatedErrors[name] = "Order value must be greater than zero";
              } 
              else {
                const isDuplicate = data.some((item) => {
                  if (item.id === editingId) return false; // skip current editing item
                  return item?.session_name === Number(value);
                });
                if (isDuplicate) {
                  updatedErrors[name] = "Order already exists";
                }
              }
            }
            }
              setFormData(updatedData);
              setErrors(updatedErrors);
            }
            catch (error) {
            console.error("Error in handleChange:", error);
          }
    };

    
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) {
        return
      }
      try{
      let response;
      const form = new FormData();
      form.append('id', formData.id);
      form.append('session_name', formData.session_name);
      form.append('session_title', formData.session_title);
      form.append('session_description', formData.session_description);
      form.append('short_description', formData.short_description);
      form.append('alt_name', formData.alt_name);
      form.append('session_url', formData.session_url);
      form.append('meta_title', formData.meta_title);
      form.append('meta_description', formData.meta_description);
      form.append('uploadedfile', formData.uploadedfile);
      
      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Added Successfully!", {
                  position: 'top-right',
                  autoClose: 3000,
                });
        } else {
          toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Updated Successfully!", {position: 'top-right', autoClose: 3000,});
          }
        } else {
          toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      }
      catch (error) {
          console.error("Error during form submission:", error);
      }
    };

    const handleDelete = async () => {
      try{
        if (selectedData) {
          const result = await deleteData(selectedData.id);
          if (result.status === 200) {
            fetchData();
            setShowDeleteConfirmModal(false);
            toast.success("Deleted Successfully!", {
                        position: 'top-right',
                        autoClose: 3000,
                      });
          } else {
            toast.error(result.message ||"Failed to Delete data. Please try again.", {position: 'top-right',});
          }
        }
    }
      catch (error) {
          console.error('Error deleting data:', error);
        }
    };
  
    
  // Handle change for Quill editor
  const handleshortdescriptionChange = (value) => {
    setErrors((prev) => ({ ...prev, short_description: isQuillContentEmpty(value) ? 'Short Description is required' : '' }));
    setFormData((prev) => ({ ...prev, short_description: value }));
  };

  const handlesessiondescriptionChange = (value) => {
    setErrors((prev) => ({ ...prev, session_description: isQuillContentEmpty(value) ? 'Long Description is required' : '' }));
    setFormData((prev) => ({ ...prev, session_description: value }));
  };
  
  const openModal = (type, data = { 
    id: null,
    uploadedfile: null, 
    session_name: '',
    session_title: '',
    session_description: '',
    short_description: '',
    alt_name: '',
    session_url: '',
    meta_title: '',
    meta_description: '' 
   }) => {
    setModalType(type);
    setFormData(data);
    setEditingId(data?.id); 
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

 


   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
        const filtered = data?.filter(
          (data) =>
          data.session_title.toLowerCase().includes(searchText.toLowerCase()) 
        );
        const sortedData = [...filtered].sort((a, b) => a.session_name - b.session_name);
        return sortedData;

      }, [data, searchText]);
    
  const columns = [
    {
        name: 'Order',
        selector: (row) => row.session_name,
        sortable: true,
        width:'10%'
      },
    // {
    //     name: 'Pic',
    //     selector: (row) => <img src={row.session_pic} width="100" alt={row.session_pic} 
    //     style={{ width: '60px', height: '40px', objectFit: 'cover' }}
    //     crossOrigin="anonymous" />,
    //     sortable: false,
    // },
    {
        name: 'Session Title',
        selector: (row) => row.session_title,
        cell: (row) => (
            <span title={row.session_title}>
              {row.session_title}
            </span>
          ),
        sortable: false,
        width:'30%'
    },
    
    {
        name: 'Alt Name',
        selector: (row) => row.alt_name,
         cell: (row) => (
            <span title={row.alt_name}>
              {row.alt_name}
            </span>
          ),
        sortable: true,
        width:'30%'
    },
    
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      uploadedfile: row.session_pic, // File input should be reset
                      session_name: row.session_name,
                      session_title: row.session_title, 
                      session_description: row.session_description, 
                      short_description: row.short_description,
                      alt_name: row.alt_name, 
                      session_url: row.session_url, 
                      meta_title: row.meta_title, 
                      meta_description: row.meta_description,     
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
      width:'30%'
    },
  ];

  useEffect(() => {
        const tooltipMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough',
          'ql-script[value="sub"]': 'Subscript',
          'ql-script[value="super"]': 'Superscript',
          'ql-blockquote': 'Blockquote',
          'ql-code-block': 'Code Block',
          'ql-color': 'Text Color',
          'ql-background': 'Background Color',
          'ql-align': 'Align',
          'ql-direction': 'Text Direction',
          'ql-list[value="ordered"]': 'Ordered List',
          'ql-list[value="bullet"]': 'Bullet List',
          'ql-indent[value="-1"]': 'Outdent',
          'ql-indent[value="+1"]': 'Indent',
          'ql-link': 'Insert Link',
          'ql-clean': 'Clear Formatting',
        };
  
      const setTooltips = () => {
        Object.entries(tooltipMap).forEach(([selector, title]) => {
          const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
          if (el && !el.title) {
            el.setAttribute('title', title);
          }
        });
      };
  
      const observer = new MutationObserver((mutations, obs) => {
        const toolbarReady = document.querySelector('.ql-toolbar');
        if (toolbarReady) {
          setTooltips();
          obs.disconnect(); // Stop observing once done
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
  
    return () => observer.disconnect() // Clean up on unmount
    }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Other Pages <b>/ Sessions</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
        
          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Order<small className='text-danger'> * </small></Form.Label>
                        <Form.Control
                            type="number"
                            name="session_name"
                            value={formData.session_name}
                            onChange={handleChange}
                            isInvalid= {!!errors.session_name}
                        />
                        <Form.Control.Feedback type="invalid">{errors.session_name}</Form.Control.Feedback>
                        
                    </Form.Group>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Session Title <small className='text-danger'> * </small></Form.Label>
                        <Form.Control
                            type="text"
                            name="session_title"
                            value={formData.session_title}
                            onChange={handleChange}
                            isInvalid= {!!errors.session_title}
                        />
                        <Form.Control.Feedback type="invalid">{errors.session_title}</Form.Control.Feedback>
                    </Form.Group>  
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>
                        Session Image <small className='text-danger'> * </small><small className="text-primary form-label-note"> (Dimension:730x250 | Size:10kb-50kb)</small>
                        </Form.Label>
                        <Form.Control
                            type="file"
                            name="uploadedfile"
                            onChange={handleChange}
                            isInvalid={!!errors.uploadedfile}
                            accept="image/*"
                        />
                    <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Alt Name <small className='text-danger'> * </small></Form.Label>
                        <Form.Control
                            type="text"
                            name="alt_name"
                            value={formData.alt_name}
                            onChange={handleChange}
                            isInvalid={!!errors.alt_name}
                        />
                      <Form.Control.Feedback type="invalid">{errors.alt_name}</Form.Control.Feedback>
                    </Form.Group>               
                    <Form.Group className="mb-3">
                    <Form.Label className='form-label-custom'>Short Description <small className='text-danger'> * </small></Form.Label>
                    <ReactQuill
                        value={formData.short_description}
                        onChange={handleshortdescriptionChange}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        placeholder="Enter description"
                        className={`react-quill-editor ${errors.short_description ? 'border border border-1 border-danger rounded' : ''}`}
                    />
                    {errors.short_description && (
                    <div className="invalid-feedback d-block">
                      {errors.short_description}
                    </div>
                  )}
                    </Form.Group>
                    <Form.Group className="mb-3">
                    <Form.Label className='form-label-custom'>Long Description <small className='text-danger'> * </small></Form.Label>
                    <ReactQuill
                        value={formData.session_description}
                        onChange={handlesessiondescriptionChange}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        placeholder="Enter description"
                        className={`react-quill-editor ${errors.session_description ? 'border border border-1 border-danger rounded' : ''}`}
                    />
                    {errors.session_description && (
                    <div className="invalid-feedback d-block">
                      {errors.session_description}
                    </div>
                  )}
                    </Form.Group>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Meta Title <small className='text-danger'> * </small> <small className='text-primary'>Char Limit: 20 -70 | Current Char Count: {formData.meta_title.length}</small></Form.Label>
                        <Form.Control
                            as="textarea"  
                            rows={8} 
                            type="text"
                            name="meta_title"
                            value={formData.meta_title}
                            onChange={handleChange}
                            isInvalid = {!!errors.meta_title}
                        />
                        <Form.Control.Feedback type="invalid">{errors.meta_title}</Form.Control.Feedback>                    
                    </Form.Group>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Meta Description <small className='text-danger'> * </small> <small className='text-primary'>Char Limit: 70 -160 | Current Char Count: {formData.meta_description.length}</small></Form.Label>
                        <Form.Control
                            as="textarea"  
                            rows={8} 
                            name="meta_description"
                            value={formData.meta_description}
                            onChange={handleChange}
                            isInvalid = {!!errors.meta_description}
                        />
                        <Form.Control.Feedback type="invalid">{errors.meta_description}</Form.Control.Feedback>
                    </Form.Group>
                </div>

                <Modal.Footer>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Sessions;